const DOCUMENT = 'AGENCIES_ACTIVE_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_LEGAL_ENTITIES_ERROR: DOCUMENT + 'LOAD_LEGAL_ENTITIES_ERROR',
  LOAD_LEGAL_ENTITIES_REQUEST: DOCUMENT + 'LOAD_LEGAL_ENTITIES_REQUEST',
  LOAD_LEGAL_ENTITIES_SUCCESS: DOCUMENT + 'LOAD_LEGAL_ENTITIES_SUCCESS',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  UPDATE_PREFERENCE_REQUEST: DOCUMENT + 'UPDATE_PREFERENCE_REQUEST',

  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadData: data => ({ type: actions.LOAD_REQUEST, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadLegalEntities: () => ({ type: actions.LOAD_LEGAL_ENTITIES_REQUEST }),
  loadLegalEntitiesError: () => ({ type: actions.LOAD_LEGAL_ENTITIES_ERROR }),
  loadLegalEntitiesSuccess: data => ({ type: actions.LOAD_LEGAL_ENTITIES_SUCCESS, payload: data }),
  updatePreference: data => ({ type: actions.UPDATE_PREFERENCE_REQUEST, payload: data }),
};

export default actions;
